const categoryData = [
    {
        title: "All",
        value: "",
    },
    {
        title: "Attraction",
        value: "point_of_interest, tourist_attraction, museum, stadium, amusement_park",
    },
    {
        title: "Bar",
        value: "bar, night_club, liquor_store",
    },
    {
        title: "Cafe",
        value: "cafe, food",
    },
    {
        title: "Restaurant",
        value: "restaurant, food",
    },
    {
        title: "Shopping",
        value: "shopping_mall, clothing_store, department_store, supermarket, store",
    },
    {
        title: "Health",
        value: "gym, health, spa, pharmacy, physiotherapist",
    },
]

const labels = {
    FREE: 0,
    INEXPENSIVE: 1,
    MODERATE: 2,
    EXPENSIVE: 3,
    "VERY EXPENSIVE": 4,
}

const CREDIT_AMOUNT = 50
const TRIAL_PERIOD_DAYS = 90

module.exports = {
    categoryData,
    labels,
    CREDIT_AMOUNT,
    TRIAL_PERIOD_DAYS,
}
